import { registerFr } from '../i18n/index.js';

registerFr({
  'Principals': 'Principaux',
  'No principal exists yet. A principal is a caller with scopes — hermes, claude-code, scout, signet — and a bearer shown once at creation and never again. Every call it makes lands in the ledger, refusals included; revoking it is one click and takes effect on the next call.': 'Aucun principal n’existe encore. Un principal est un appelant avec des portées — hermes, claude-code, scout, signet — et un jeton montré une seule fois à la création, jamais ensuite. Chacun de ses appels est consigné au registre, refus compris ; le révoquer est un clic et prend effet dès l’appel suivant.',
  'who may call what · a bearer shown once, stored as a hash': 'qui peut appeler quoi · un jeton montré une fois, conservé en hachage',
  'Close form': 'Fermer le formulaire',
  'New principal →': 'Nouveau principal →',
  'New principal': 'Nouveau principal',
  'Token for {name} — shown once': 'Jeton de {name} — montré une seule fois',
  'New token for {name} — shown once': 'Nouveau jeton de {name} — montré une seule fois',
  'Copy it now into the caller\'s environment. The server keeps only its hash; there is no way to see it again — losing it means rotating.': 'Copiez-le maintenant dans l’environnement de l’appelant. Le serveur n’en garde que le hachage ; il n’y a aucun moyen de le revoir — le perdre, c’est le renouveler.',
  'the bearer token': 'le jeton bearer',
  'Copy': 'Copier',
  'Token copied.': 'Jeton copié.',
  'Could not copy; select it by hand.': 'Copie impossible ; sélectionnez-le à la main.',
  'I have stored it': 'Je l’ai conservé',
  'Could not load the principals: {error}': 'Impossible de charger les principaux : {error}',
  'Principal': 'Principal',
  'Kind': 'Type',
  'Scopes': 'Portées',
  'Token': 'Jeton',
  'Rate': 'Débit',
  'Last seen': 'Dernier appel',
  'Calls · 24h': 'Appels · 24 h',
  '/min': '/min',
  'conc.': 'simult.',
  'never': 'jamais',
  'revoked': 'révoqué',
  'expired': 'expiré',
  'no token': 'sans jeton',
  'expires {date}': 'expire le {date}',
  // 'Status' is translated by InboxPage / OrganisationPage; 'live' here is a context variant (tCtx): a
  // principal is live as opposed to revoked, not live as opposed to indexed (SearchPage).
  'live\u2016principal': 'actif',
  'external': 'externe',
  'internal': 'interne',
  'worker': 'worker',
  'system': 'système',
  'Rotate…': 'Renouveler…',
  'Revoke…': 'Révoquer…',
  'Rotate': 'Renouveler',
  'Revoke': 'Révoquer',
  'Mint a new token; the old one stops working at once.': 'Émettre un nouveau jeton ; l’ancien cesse aussitôt de fonctionner.',
  'The next call with this token answers 401.': 'Le prochain appel avec ce jeton reçoit 401.',
  'Revoke {name}?': 'Révoquer {name} ?',
  'Rotate the token of {name}?': 'Renouveler le jeton de {name} ?',
  '{name} revoked. Its next call answers 401.': '{name} révoqué. Son prochain appel reçoit 401.',
  'Its next call answers 401 and is not ledgered. The ledger rows it already wrote stay under its name. This cannot be undone; create a new principal instead.': 'Son prochain appel reçoit 401 et n’est pas consigné. Les lignes de registre déjà écrites restent à son nom. Irréversible ; créez plutôt un nouveau principal.',
  'A new bearer is minted and shown once; the current one stops working at the same instant. Update the caller\'s environment right after.': 'Un nouveau jeton est émis et montré une fois ; l’actuel cesse de fonctionner au même instant. Mettez à jour l’environnement de l’appelant juste après.',
  'Name': 'Nom',
  'A principal with this name exists; rotate or revoke it instead.': 'Un principal de ce nom existe ; renouvelez-le ou révoquez-le plutôt.',
  'Rate per minute': 'Appels par minute',
  'Max concurrency': 'Simultanéité max.',
  'Expires on': 'Expire le',
  'Sending is an operator click on the Inbox. The registry refuses to boot with a send scope.': 'Envoyer est un clic de l’opérateur dans la boîte de réception. Le registre refuse de démarrer avec une portée send.',
  'Create and show the token': 'Créer et montrer le jeton',
  'The token appears once, right here, after creation.': 'Le jeton apparaît une seule fois, ici même, après la création.',
}, 'PrincipalsPanel');
